import { makeStyles } from '@material-ui/core/styles';

export const useNoBenefitsStyles = makeStyles(() => ({
  container: {
    marginTop: 50,
  },
  boxDesktop: {
    display: 'grid',
    gridTemplateColumns: '45% 45%',
    justifyContent: 'space-between',
    marginBottom: '45px',
  },
  boxMobile: {
    display: 'grid',
    direction: 'column',
    rowGap: '20px',
    marginTop: '40px',
    marginBottom: '45px',
  },
  divider: {
    '&.MuiDivider-root': {
      backgroundColor: '#ababab',
    },
    marginBottom: 20,
  },
}));

export const useBenefitsListStyles = makeStyles((theme) => ({
  container: {
    border: '1px solid #d9d9d9',
    borderRadius: 10,
    boxShadow: '0px 3px 6px #00000029',
    padding: '17px 20px',
    '& > *': {
      textAlign: 'center',
    },
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: 18,
    marginTop: 40,
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10,
    marginTop: 10,
  },
  image: {
    marginBottom: 8,
  },
  button: {
    textAlign: 'center',
  },
}));
